import { Navigate } from "react-router-dom";

export default function UserPageSuperAdmin() {
  return <Navigate to="/user/administration" replace />;
}
